import {createContext} from "react";

//lang code, available in all the application
export const LangContext = createContext({ lang: "en", setLang: () => {} })
//user info, contains name, nickname, profile-pic, etc, available in all the application
export const UserDataContext = createContext({});
//contains all the texts to show, available in all the application
export const UiTextsContext = createContext({});
// Register User
export const RegisterUserContext = createContext("");